var map = {
	"./tokenlist-bit.json": 8947,
	"./tokenlist-bitswap.json": 94817,
	"./tokenlist-btn10086.json": 16192,
	"./tokenlist-dev.json": 55667,
	"./tokenlist-keke.json": 77100,
	"./tokenlist-main.json": 31865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55908;